import { createTheme } from '@mui/material'
import { itIT } from '@mui/material/locale'
import { itIT as itITGriglia } from '@mui/x-data-grid/locales'

// Colori e font del sito pubblico (apps/site/src/styles/tokens.css): chi passa dal
// sito al portale deve riconoscere lo stesso prodotto.
export const PRIMARIO = '#1d4ed8'
export const PRIMARIO_SCURO = '#1e3a8a'
export const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif"

export const tema = createTheme({
  palette: {
    primary: { main: PRIMARIO, dark: PRIMARIO_SCURO },
    secondary: { main: '#ea580c', contrastText: '#0f172a' },
    success: { main: '#15803d' },
    error: { main: '#b91c1c' },
    background: { default: '#f8fafc', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#475569' },
    divider: '#e2e8f0',
  },
  typography: {
    fontFamily: FONT,
    button: { textTransform: 'none', fontWeight: 600 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
  },
}, itIT, itITGriglia)
